import { render, staticRenderFns } from "./ItemOverview.vue?vue&type=template&id=abc0d772&"
import script from "./ItemOverview.vue?vue&type=script&lang=js&"
export * from "./ItemOverview.vue?vue&type=script&lang=js&"
import style0 from "./ItemOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports